import { render, staticRenderFns } from "./InfoTip.vue?vue&type=template&id=49bac198&"
import script from "./InfoTip.vue?vue&type=script&lang=js&"
export * from "./InfoTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports